// extracted by mini-css-extract-plugin
export default {"imageContainer":"W1-z","summaryPar":"X1-z","ratingCategories":"Y1-z","reviewerInfo":"Z1-z","reviewTypes":"_1-z","expanded":"a2-z"};